module.exports = __webpack_public_path__ + "img/dl_1109_2.f31e381c.jpg";